<template>
    <div class="mapTop" :class="{scrolled: scrolledMapTopRef, visible: (this.isOpen || this.isOpenCity), overflow: this.overflowMapTopRef}">
        <div class="row nowrap" ref="mapTopRef">
            <div class="col-auto">
              <button role="button" class="loc" data-oki="#city" :aria-expanded="this.isOpenCity" 
                @keydown.space.prevent="handleExpanderClickCity()"
                @keydown.enter.prevent="handleExpanderClickCity()"
                @click.prevent="handleExpanderClickCity()" 
                :aria-label="$t('resultpage.select_location_dropdown_label')">
                <span class='icon icon-pin2'></span>
                <span class="val">{{ this.getCityName() }}</span>
                <span class='icon icon-down'></span>
              </button>
              <div class="okiCollapse okiDropdown" :class="{open: this.isOpenCity}" :style="{'left': 0}" id="city">
                <div class="row">
                  <div class="col-12">
                    <ul>
                      <li v-for="(item, idx) in this.cities" :key="'city_'+idx"
                      >
                        <button role="button"
                          @click.prevent="handleChangeCity"
                          @keydown.space.prevent="handleChangeCity"
                          @keydown.enter.prevent="handleChangeCity"
                           :data-id="item.id" >{{this.getCityNameByItem(item)}}</button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <!-- <a class="loc"><span class='icon icon-pin2'></span> <span class="val" v-html="this.getCityName()" /></a>-->
            </div>
            <div class="col-auto">
                <button role="button" class="cat" data-oki="#cat" :aria-expanded="this.isOpen" 
                  @keydown.space.prevent="handleExpanderClick()"
                  @keydown.enter.prevent="handleExpanderClick()"
                  @click.prevent="handleExpanderClick()" 
                  :aria-label="$t('resultpage.select_category_dropdown_label')">
                    <span class='icon icon-case'></span> 
                    <span class="val">{{ this.getCurrentCat() }}</span>
                    <span class='icon icon-down'></span>
                </button>
                <div class="okiCollapse okiDropdown" :class="{open: this.isOpen}" id="cat">
                    <div class="row">
                        <div class="col-12">
                            <ul>
                                <li v-for="(item, idx) in this.industries" :key="'industry_'+idx"
                                    >
                                    <button role="button"
                                        @click.prevent="handleChangeCat"
                                        @keydown.space.prevent="handleChangeCat"
                                        @keydown.enter.prevent="handleChangeCat"
                                        :data-value="item.name"
                                        :data-id="item.id" >{{this.getIndustryName(item)}}</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-auto" v-if="squareInfo">
                <button role="button" class="hide" 
                  @keydown.space.prevent="handeShowPins"
                  @keydown.enter.prevent="handeShowPins"
                  @click.prevent="handeShowPins"
                  :aria-label="$t('resultpage.show_hide_pins_label')"
                  >
                    <span class='icon icon-storefront2'></span> 
                    <span class="val">
                        <span v-if="this.showPins">{{$t('hide_offers')}}</span>
                        <span v-else>{{$t('show_offers')}}</span>
                    </span>
                </button>
            </div>
            <div class="col-auto" >
                <button role="button"
                  @keydown.space.prevent="handeShowScores"
                  @keydown.enter.prevent="handeShowScores"
                  @click.prevent="handeShowScores"
                  :aria-label="$t('resultpage.show_hide_scores_label')"
                  >
                    <span class='icon icon-icon'></span> 
                    <span class="val">
                        <span v-if="this.showScores">{{$t('hide_scores')}}</span>
                        <span v-else>{{$t('show_scores')}}</span>
                    </span>
                </button>
            </div>
            <div class="col-auto selectSquareDrop">
                <button role="button" class="squaresList" data-oki="#squaresList" :aria-expanded="this.isOpenSquaresList" 
                  @keydown.space.prevent="handleExpanderClickSquareList()"
                  @keydown.enter.prevent="handleExpanderClickSquareList()"
                  @click.prevent="handleExpanderClickSquareList()" 
                  :aria-label="$t('resultpage.select_square_list_dropdown_label')">
                    <span class="val">{{ this.curentSquare }}</span>
                    <span class='icon icon-down'></span>
                </button>
                <div class="okiCollapse okiDropdown" :class="{open: this.isOpenSquaresList}" id="squareList">
                    <div class="row">
                        <div class="col-12">
                            <ul>
                                <!-- <li><a href="#">987987987</a></li> -->
                                <li v-for="(item, idx) in this.squares.features" :key="'square_'+idx"
                                    >
                                    <button role="button"
                                      @click.prevent="handleChangeSquare"
                                      @keydown.space.prevent="handleChangeSquare"
                                      @keydown.enter.prevent="handleChangeSquare"
                                      :data-external="item.properties.externalId"
                                      :data-value="item.properties"
                                      :data-id="item.properties.id" >{{ item.properties.externalId }}</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <button role="button" class="scroll"
          @keydown.space.prevent="handleMapTopRowScrollRight"
          @keydown.enter.prevent="handleMapTopRowScrollRight"
          @click.prevent="handleMapTopRowScrollRight"><span class='icon icon-next'></span></button>
    </div>
</template>

<script>
export default {
    name: 'GlobalMapTop',
    props: {
        categories: {type: Array},
        squareInfo: {type: Object}
    },
    data() {
      return {
        scrolledMapTopRef: false,
        overflowMapTopRef: false,
        city: null,
        industries: [],
        cities: [],
        squares: [],
        isOpen: false,
        isOpenCity: false,
        isOpenSquaresList: false,
        showPins: false,
        showScores: false,
        curentCat: this.$t('category'),
        curentSquare: this.$t('resultpage.select_square_list_dropdown'),
        curentSquareProp: [],
        curentCatId: null
      }
    },
    mounted() {
      if(this.city === null) {
        this.$store.dispatch('fetchCity', this.$store.state.quiz.city.id).then((response) => {
          this.city = response;
        });
      }
      if(this.$store.state.industries.length > 0)
        this.industries = this.$store.state.industries;
      else {
        this.$store.dispatch('fetchIndustries').then((response) => {
          this.industries = response;
        });
      }
      if(this.$store.state.cities.length > 0)
        this.cities = this.$store.state.cities;
      else {
        this.$store.dispatch('fetchCities').then((response) => {
          this.cities = response;
        });
      }

      if(this.$store.state.squares) {
        this.squares = this.$store.state.squares;
        console.log('squares from store', this.squares);
      } else {
        if(this.city === null) {
          this.$store.dispatch('fetchCity', this.$store.state.quiz.city.id).then((response) => {
            this.city = response;

            this.$store.dispatch('fetchSquares', {'cityId': this.city.id}).then((response) => {
              this.squares = response;
              console.log('squares from api', this.squares);
            });
          });
        }
      }

      this.$emit('showPins', this.showPins);
      this.$emit('showScores', this.showScores);

      if (window.innerWidth < 1024) {
        var _t = this;
        window.addEventListener('resize', _t.handleMapTopMobileOverflow);
      }
    },
    unmounted() { 
      var _t = this;
      window.removeEventListener('resize', _t.handleMapTopMobileOverflow);
    },
    updated() {
      if (window.innerWidth < 1024) {
        var _t = this;
        _t.handleMapTopMobileOverflow;
      }
    },
    watch: {
        industries: function(newVal, oldVal) {
            if(oldVal.length == 0 && newVal.length > 0) {
              for(var idx in this.industries) {
                if(this.industries[idx].id == this.$store.state.quiz.industry) {
                  this.curentCat = this.getIndustryName(this.industries[idx]);
                  this.curentCatId = this.industries[idx].id;
                }
              }
            }
        },
        squareInfo: function(val) {
          console.log('squareInfo', val);
          if (val != null) {
            this.curentSquare = val.externalId
          }
        },
        overflowMapTopRef: function() {
          // console.log('watch handleMapTopMobileOverflow', params);
        }
    },
    methods: {
        getCurrentCat() {
          if(this.curentCat == null)
            return this.$t('category');
          for(var idx in this.industries) {
            if(this.industries[idx].id == this.curentCatId) {
              return this.getIndustryName(this.industries[idx]);
            }
          }
          return this.$t('category');
        },
        handleMapTopMobileOverflow() {
          // console.log('handleMapTopMobileOverflow', this.$refs, window.innerWidth);
          if(this.$refs.mapTopRef == null)
            return;
          if (window.innerWidth < 1024 && this.$refs.mapTopRef != null) {
            var mapTopWrapperWidth = this.$refs.mapTopRef.offsetWidth;
            var mapTopChildrenLen = this.$refs.mapTopRef.children.length;
            var mapTopChildrenWidth = 0;
            if (mapTopChildrenLen > 0) {
              mapTopChildrenWidth = Object.values(this.$refs.mapTopRef.children).reduce((total, i) => total + i.offsetWidth, 0) + (8 * (mapTopChildrenLen - 1));
            }
            if (mapTopWrapperWidth < mapTopChildrenWidth) {
              this.overflowMapTopRef = true;
            } else {
              this.overflowMapTopRef = false;
            }
          }
          // console.log('handleMapTopMobileOverflow ww', window.innerWidth, mapTopWrapperWidth, mapTopChildrenWidth, mapTopChildrenLen);
        },
        getIndustryName(item) {
          if(this.$store.state.lang == 'pl')
            return item.name;
          else if(this.$store.state.lang == 'en')
            return item.nameEn;
          else if(this.$store.state.lang == 'uk')
            return item.nameUk;

        },
        getCityNameByItem(item) {
          if(this.$store.state.lang == 'pl')
            return item.name;
          else if(this.$store.state.lang == 'en')
            return item.nameEn;
          else if(this.$store.state.lang == 'uk')
            return item.nameUk;
        },
        getCityName() {
          if(this.city != null) {

            if(this.$store.state.lang == 'pl')
              return this.city.name;
            else if(this.$store.state.lang == 'en')
              return this.city.nameEn;
            else if(this.$store.state.lang == 'uk')
              return this.city.nameUk;

            return this.city.name
          }

          return '';
        },
        handleMapTopRowScrollRight() {
            console.log(this.$refs.mapTopRef.scrollLeft);
            if (this.scrolledMapTopRef) {
                this.$refs.mapTopRef.scrollLeft = 0;
                this.scrolledMapTopRef = false;
            } else {
                this.$refs.mapTopRef.scrollLeft = 150;
                this.scrolledMapTopRef = true;
            }
        },
        handleExpanderClick() {
            if(this.isOpen) {
                this.isOpen = false;
                // document.body.classList.remove('okiCollapseOpen');
            } else {
                this.isOpen = true;
                this.isOpenCity = false;
                this.isOpenSquaresList = false;
                // document.body.classList.add('okiCollapseOpen');
            }
        },
        handleExpanderClickCity() {
          if(this.isOpenCity) {
            this.isOpenCity = false;
            // document.body.classList.remove('okiCollapseOpen');
          } else {
            this.isOpenCity = true;
            this.isOpen = false;
            this.isOpenSquaresList = false;
            // document.body.classList.add('okiCollapseOpen');
          }
        },
        handleExpanderClickSquareList() {
          // console.log('squareInfo', this.squareInfo);
          if (!this.squares) {
            this.$store.dispatch('fetchSquares', {'cityId': this.city.id}).then((response) => {
              // console.log('fetchSquares response',response);
              this.squares = response;
            });
          }

          if(this.isOpenSquaresList) {
            this.isOpenSquaresList = false;
          } else {
            this.isOpenSquaresList = true;
            this.isOpen = false;
            this.isOpenCity = false;
          }
        },
        handleChangeSquare(e) {
            this.curentSquare = e.target.dataset.external;
            this.curentSquareProp = e.target.dataset.value;
            this.isOpenSquaresList = false;
            // this.$emit('changeSquare', this.curentSquareProp);
            this.$emit('changeSquare', this.curentSquare);
        },
        handleChangeCat(e) {
            this.curentCat = e.target.dataset.value;
            this.curentCatId = e.target.dataset.id;
            this.isOpen = false;
            // console.log(e, 'handleChangeCat');
            this.$emit('changeCat', this.curentCatId);
            this.reportCategory();
        },
        handleChangeCity(e) {
          for(var idx in this.cities) {
            if(this.cities[idx].id == e.target.dataset.id) {
              this.city = this.cities[idx];
            }
          }

          this.isOpenCity = false;
          this.$emit('changeCity', this.city);
        },
        handeShowPins() {
            this.showPins = !this.showPins;
            this.$emit('showPins', this.showPins);
            this.reportToggleOffers();
        },
        handeShowScores() {
            this.showScores = !this.showScores;
            this.$emit('showScores', this.showScores);
            // console.log('handeShowScores', this.showScores);
        },
        reportCategory() {

          var clickInfoObject = {
            "ctaName" : "Category",
            "ctaType" : "Button",
            "ctaLocation" : "header",
            "categoryName": "["+this.curentCat+"]"
          };

          window.adobeDataLayer.push({ "event" : "ctaClick",
            "clickInfo" : clickInfoObject});

        },
        reportToggleOffers() {

          var clickInfoObject = {
            "ctaName" : "Offers",
            "ctaType" : "Button",
            "ctaLocation" : "header",
            "showHide": "["+(this.showPins ? 'On' : 'Off')+"]"
          };

          window.adobeDataLayer.push({ "event" : "ctaClick",
            "clickInfo" : clickInfoObject});

        }
    }
}
</script>